import { createReducer, createActions } from 'reduxsauce';
import { getDistance } from 'utils/geolocation';

/* ------------------- Types and Action Creators -------------- */
const { Types, Creators } = createActions({
  reset: [],
  startup: [],
  setToast: ['message', 'color'],
  setVenue: ['venueId'],
  setVenues: ['venues'],
  setLoaded: ['loaded'],
  setLoadingVenues: ['loadingVenues'],
  setGeoLocation: ['lat', 'lng'],
  setInvite: ['invite'],
});

export const AppTypes = Types;

export default Creators;

/* ---------------- Selectors -------------- */
export const AppSelectors = {
  selectLoaded: (state) => state.app.loaded,
  selectLoadingVenues: (state) => state.app.loadingVenues,
  selectVenue: (state) => state.app.venueId,
  selectGeoLocation: (state) => ({
    lat: state.app.lat,
    lng: state.app.lng,
  }),
  selectVenues: (state) =>
    state.app.venues.sort((a, b) => {
      const d1 = getDistance(a.lat, a.lng, state.app.lat, state.app.lng);
      const d2 = getDistance(b.lat, b.lng, state.app.lat, state.app.lng);

      return d1 - d2;
    }),
  selectVenueDetail: (state) => {
    return state.app.venues.find((t) => t.id === state.app.venueId);
  },
  selectVenueDetailById: (venueId) => (state) => {
    return state.app.venues.find((t) => t.id === venueId);
  },
  selectToast: (state) => state.app.toast,
  selectInvite: (state) => state.app.invite,
  selectInviteVenue: (state) =>
    state.app.invite
      ? state.app.venues.find((v) => v.id === state.app.invite.venueId)
      : null,
};

/* ---------------- Initial State -------------- */
export const INITIAL_STATE = {
  venues: [],
  loaded: false,
  loadingVenues: false,
  venueId: null,
  toast: null,
  lat: null,
  lng: null,
  invite: null,
};

/* ---------------- Reducers -------------- */
export const setLoaded = (state, { loaded }) => ({
  ...state,
  loaded,
});

export const setLoadingVenues = (state, { loadingVenues }) => ({
  ...state,
  loadingVenues,
});

export const setVenue = (state, { venueId }) => ({
  ...state,
  venueId,
});

export const setToast = (state, { message, color }) => ({
  ...state,
  toast: message
    ? {
        message,
        color,
      }
    : null,
});

export const setVenues = (state, { venues }) => ({
  ...state,
  venues,
});

export const setGeoLocation = (state, { lat, lng }) => ({
  ...state,
  lat,
  lng,
});

export const setInvite = (state, { invite }) => ({
  ...state,
  invite,
});

export const reset = () => ({ ...INITIAL_STATE, loaded: true });

export const reducer = createReducer(INITIAL_STATE, {
  [Types.SET_LOADED]: setLoaded,
  [Types.SET_LOADING_VENUES]: setLoadingVenues,
  [Types.SET_VENUE]: setVenue,
  [Types.SET_TOAST]: setToast,
  [Types.SET_VENUES]: setVenues,
  [Types.SET_GEO_LOCATION]: setGeoLocation,
  [Types.SET_INVITE]: setInvite,
  [Types.RESET]: reset,
});
